import { MasterModuleLayout, useMasterModule } from "../Common";
import { useGetPaymentMethodIncludeDelete, useToggleStatusMutation } from "@/services";

const PaymentMethod = () => {
  const masterHook = useMasterModule({
    queryKey: "payment-method",
    idKey: "paymentMethodId",
    nameKey: "methodName",
    useGetDataQuery: useGetPaymentMethodIncludeDelete,
    useToggleStatusMutation: useToggleStatusMutation,
    module: "payment-method",
    statusSuccessMessage: "Payment Method Status Updated Successfully",
  });

  return <MasterModuleLayout title="Payment Method" hookResult={masterHook} />;
};

export default PaymentMethod;
